import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { Observable, map } from 'rxjs';

import { CamPermissionsService } from '@camelot/user';

@Injectable({
  providedIn: 'root',
})
export class UnauthenticatedAzureGuard {
  public readonly _permissionsService = inject(CamPermissionsService);
  private readonly router = inject(Router);

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (!this._permissionsService.received) {
      return this._permissionsService.updated$.pipe(
        map(() => {
          if (!this._permissionsService.isAuthenticated) {
            return true;
          } else {
            this.setRedirect();
            return false;
          }
        })
      );
    }
    if (this._permissionsService.isAuthenticated) {
      this.setRedirect();
      return false;
    }
    return true;
  }

  public setRedirect(): void {
    this.router.navigateByUrl('');
  }
}
